var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconQuestionProblem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-question-problem"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-question-problem",
    clipPath: "url(#clip-icon-question-problem)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(-482 -628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    transform: "translate(482 628)",
    fill: "red",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(2.996 3.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-alert-triangle",
    "data-name": "Icon feather-alert-triangle",
    transform: "translate(486 632.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M6.081,4.759,2.443,10.833a.859.859,0,0,0,.734,1.289h7.276a.859.859,0,0,0,.734-1.289L7.55,4.759a.859.859,0,0,0-1.469,0Z",
    transform: "translate(-2.328 -4.346)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M.332-3.075H-.829L-1.012-6.3H.512ZM.566-2.04a.631.631,0,0,1-.219.5.852.852,0,0,1-.585.193.853.853,0,0,1-.582-.2.626.626,0,0,1-.226-.492.6.6,0,0,1,.219-.484.882.882,0,0,1,.589-.185.88.88,0,0,1,.582.185A.6.6,0,0,1,.566-2.04Z",
    transform: "translate(490.871 640.386)",
    fill: "red"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-question",
    "data-name": "Icon awesome-question",
    d: "M4.355,0A2.806,2.806,0,0,0,1.862,1.318a.348.348,0,0,0,.075.476l.625.474a.348.348,0,0,0,.482-.06,1.405,1.405,0,0,1,1.2-.716c.446,0,1,.287,1,.719,0,.327-.27.494-.71.741-.513.288-1.192.646-1.192,1.541v.142a.348.348,0,0,0,.348.348h1.05a.348.348,0,0,0,.348-.348V4.551C5.083,3.931,6.9,3.9,6.9,2.225A2.489,2.489,0,0,0,4.355,0ZM4.21,5.409a1,1,0,1,0,1,1A1,1,0,0,0,4.21,5.409Z",
    transform: "translate(484.648 631.061)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionProblem);
export default __webpack_public_path__ + "static/media/icon-question-problem.1cd3d635d63a2eb2c0e5b35e41ff808e.svg";
export { ForwardRef as ReactComponent };